import type { VariantPage } from "@/lib/api/formatting/rorosTweed/productPage";

import UI from "./UI";

type Props = { series: VariantPage["relatedSeries"] };

const SeriesCards = (props: Props = { series: [] }) => {
  return <UI {...props} />;
};

export default SeriesCards;
